import { TextControlProps } from "types";
import NumericControl from "../numeric-control/numeric-control";

interface MoneyControlProps extends Omit<TextControlProps, "placeholder" | "type" | "pattern" | "compareTo"> {
	limit?: number;
}

const MoneyControl = (props: MoneyControlProps) => {
	return (
		<NumericControl
			{...props}
			placeholder="$0.00"
			allowNegative={false}
			decimalScale={2}
			thousandSeparator={true}
			prefix={"$"}
			fixedDecimalScale={true}
		/>
	);
};

export default MoneyControl;